import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  APPOINTMENT_MAKE_NEW_KK_TELEPAEDS_CHILD_DETAILS_PATH,
  APPOINTMENT_MAKE_NEW_KK_TELEPAEDS_REQUESTOR_DETAILS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const ChildDetailsPage = lazy(() => import('./pages/ChildDetailsPage/ChildDetailsPage'));
const RequestorDetailsPage = lazy(() => import('./pages/RequestorDetailsPage/RequestorDetailsPage'));

export const KK_TELEPAEDS_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <ChildDetailsPage />,
    displayTitle: () => 'KK TelePaeds',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_KK_TELEPAEDS_CHILD_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <RequestorDetailsPage />,
    displayTitle: () => 'KK TelePaeds',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_MAKE_NEW_KK_TELEPAEDS_REQUESTOR_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
];
